import { Consent } from "@fruugo/utilities";
import { ManageConsentScreen } from "./ManageConsentScreen";
import { i18n } from "../../i18n";
import { closeModal, updateModal } from "./Modal";
import { ModalType } from "./types";
import { updateConsents } from "../../consent";

type ConsentModalProps = {
  consents: Consent;
};

export const ConsentModalContent = ({ consents }: ConsentModalProps) => {
  return (
    <>
      <article class="p-16">
        <h2 className="h3 fw-bold">{i18n("consent.modal.title")}</h2>
        <p>{i18n("consent.modal.description-1")}</p>
        <p>{i18n("consent.modal.description-2")}</p>
        <p>{i18n("consent.modal.description-3")}</p>
        <p
          dangerouslySetInnerHTML={{
            __html: i18n("consent.modal.description-4"),
          }}
          className="mb-0"
        ></p>
      </article>
      <div class="p-16 d-flex flex-column flex-md-row-reverse gap-4">
        <button
          class="button button-blue"
          onClick={handleAcceptAll}
          data-testid="cookie-consent-accept-all-button"
        >
          {i18n("consent.modal.action.accept")}
        </button>
        <button
          class="button button-secondary"
          onClick={() => handleManage(consents)}
        >
          {i18n("consent.modal.action.customise")}
        </button>
        <button class="button button-secondary" onClick={handleDeclineAll}>
          {i18n("consent.modal.action.reject")}
        </button>
      </div>
    </>
  );
};

const handleAcceptAll = () => {
  const consents: Consent = {
    essential: true,
    analytics: true,
    advertising: true,
  };

  updateConsents(consents);
  closeModal();
};

const handleManage = (consents: Consent) => {
  updateModal(
    ModalType.CookieConsent,
    <ManageConsentScreen
      consents={consents}
      handleAcceptAll={handleAcceptAll}
      handleDeclineAll={handleDeclineAll}
    />
  );
};

export const handleDeclineAll = () => {
  const consents: Consent = {
    essential: true,
    analytics: false,
    advertising: false,
  };

  updateConsents(consents);
  closeModal();
};
